export default __webpack_public_path__ + "static/media/logo.7a4fc110.svg";